const ColorLegend = ({ colorScale, maxValue }) => {
  const legendItems = [
    {
      value: Math.round(Math.pow(maxValue, 1)),
      color: colorScale(Math.pow(maxValue, 1)),
      labelPosition: 100,
    },
    {
      value: Math.round(Math.pow(maxValue, 0.75)),
      color: colorScale(Math.pow(maxValue, 0.75)),
      labelPosition: 75,
    },
    {
      value: Math.round(Math.pow(maxValue, 0.5)),
      color: colorScale(Math.pow(maxValue, 0.5)),
      labelPosition: 50,
    },
    {
      value: Math.round(Math.pow(maxValue, 0.25)),
      color: colorScale(Math.pow(maxValue, 0.25)),
      labelPosition: 25,
    },
    {
      value: Math.round(Math.pow(maxValue, 0.0)),
      color: colorScale(Math.pow(maxValue, 0.0)),
      labelPosition: 0,
    },
  ];

  const legendHeight = 140;

  return (
    <div className="color-legend">
      {/* {legendItems.map((item) => {
        return (
          <div className="legend-item">
            <div
              className="legend-item--color-block"
              style={{ backgroundColor: item.color }}
            ></div>
            <div className="legend-item--text">{item.value}</div>
          </div>
        );
      })} */}
      <div
        className="color-legend-new"
        style={{
          backgroundImage: `linear-gradient(to top, ${legendItems[4].color}, ${legendItems[2].color} 50%, ${legendItems[0].color})`,
          height: legendHeight,
        }}
      >
        {legendItems.map((item) => {
          return (
            <div
              className="legend-item-value-container"
              style={{
                bottom: legendHeight * (item.labelPosition / 100) - 8,
              }}
            >
              <div className="legend-item-value-tick"></div>
              <div className="legend-item-label">
                <div className="legend-item-label-value">{item.value}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ColorLegend;
